const API_BASE_URL = process.env.REACT_APP_API_URL || 'https://your-api-gateway-url.execute-api.us-east-1.amazonaws.com/prod';

export const visitorService = {
  // Log a visitor
  async logVisit(page = '/') {
    try {
      const response = await fetch(`${API_BASE_URL}/api/visitor`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ page }),
      });
      return await response.json();
    } catch (error) {
      console.error('Error logging visit:', error);
      return null;
    }
  },

  // Get visitor count
  async getVisitorCount() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/visitor-count`);
      const data = await response.json();
      return data.count || 0;
    } catch (error) {
      console.error('Error getting visitor count:', error);
      return 0;
    }
  },

  // Get all visitors (admin)
  async getVisitors(limit = 100) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/visitors?limit=${limit}`);
      const data = await response.json();
      return data.visitors || [];
    } catch (error) {
      console.error('Error getting visitors:', error);
      return [];
    }
  },

  // Reset all visitors (admin)
  async resetVisitors() {
    try {
      const response = await fetch(`${API_BASE_URL}/api/visitors/reset`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error resetting visitors:', error);
      throw error;
    }
  },
};

export const commentService = {
  // Submit a comment
  async submitComment(name, email, comment) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/comments`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ name, email, comment }),
      });
      return await response.json();
    } catch (error) {
      console.error('Error submitting comment:', error);
      throw error;
    }
  },

  // Get approved comments
  async getComments(admin = false) {
    try {
      const url = admin 
        ? `${API_BASE_URL}/api/comments?admin=true`
        : `${API_BASE_URL}/api/comments`;
      const response = await fetch(url);
      const data = await response.json();
      return data.comments || [];
    } catch (error) {
      console.error('Error getting comments:', error);
      return [];
    }
  },

  // Approve a comment (admin)
  async approveComment(commentId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/comments/${commentId}/approve`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error approving comment:', error);
      throw error;
    }
  },

  // Delete a comment (admin)
  async deleteComment(commentId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/comments/${commentId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return await response.json();
    } catch (error) {
      console.error('Error deleting comment:', error);
      throw error;
    }
  },
};
